'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import {TwitterButton,EmailButton, FacebookButton} from 'react-social'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import greenInactive from '../../../static/images/icn-oil-green-inactive.svg'

var Styles = require('./Home.css');

var Home = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));

    _this.renderCompanies = function () {
      return _config2.default.familyFunds.map(function (company, idx) {
        return _this.renderCompany(idx, company.name, company.t_all_asset, company.rating);
      });
    };

    _this.renderCompany = function (idx, title, asset, rating) {
      var titleURI = encodeURIComponent(title);
      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { key: idx, styleName: 'companies-box-wrap', xs: 12, sm: 4 },
        _react2.default.createElement(
          _components.Link,
          {
            onMouseEnter: _this.onMouseEnter('company-' + idx),
            onMouseLeave: _this.onMouseLeave('company-' + idx),
            log: _analytics2.default.eventToFamily(title),
            to: _config2.default.routes.families + '?q=' + titleURI,
            styleName: 'companies-link',
            title: title },
          _react2.default.createElement(
            'div',
            { styleName: 'companies-box-' + rating },
            _react2.default.createElement(
              'div',
              { styleName: 'box-title-wrapper' },
              _react2.default.createElement(
                'div',
                { styleName: 'box-title' },
                title
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'box-subtitle' },
              ' ',
              _format2.default.money(asset),
              ' in Tobacco and Studios'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'learn-more-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'learn-more-' + rating },
                ' Learn more',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var link = _config2.default.domain;
      var message = _config2.default.shareMessage;

      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      var ucsfSmokeFreeMoviesLogo = require('../../../static/images/ucsf-smokefreemovies-logo.png');
      var ucsfTobaccoLogo = require('../../../static/images/ucsf-tobacco-logo.png');
      var comcastIcon = require('../../../static/images/icn-comcast-200.png');
      var foxIcon = require('../../../static/images/icn-fox-200.png');
      var sonyIcon = require('../../../static/images/icn-sony-200.png');
      var warnerbrothersIcon = require('../../../static/images/icn-timewarner-200.png');
      var viacomIcon = require('../../../static/images/icn-viacom-200.png');
      var indiesIcon = require('../../../static/images/icn-indies-200.png');

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner-wrapper' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'banner-title' },
                'Are your savings going up in smoke?'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-btn-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  'Find mutual funds and ETFs that avoid investments in tobacco companies and entertainment companies that promote smoking'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    bigbutton: true,
                    title: 'Top-scoring funds' },
                  _react2.default.createElement(
                    'div',
                    null,
                    'Top-scoring funds',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-tagline' },
                'Search for funds from your 401(k), retirement plan, or personal portfolio'
              ),
              _react2.default.createElement(_components.AutocompleteSearch, null),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-btn-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'logo-tagline' },
                  'A project of'
                ),
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.ays, title: 'As You Sow' },
                  _react2.default.createElement('img', {
                    styleName: 'logo-ays',
                    src: aysLogo,
                    alt: 'As You Sow'
                  }),
                  _react2.default.createElement(
                    _components.SrOnly,
                    null,
                    'As You Sow'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-lede' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-lede-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-title' },
              'Making kid-rated movies smokefree would save over 1,000,000 lives'
            ),
            _react2.default.createElement('div', { styleName: 'x-lede-subtitle' }),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-info-photo' },
              _react2.default.createElement('div', {
                styleName: 'x-lede-photo',
                title: 'Warning: Watching movies with smoking poses a risk to your child\'s health'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-lede-info' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'x-lede-top' },
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Invest your values.'
                  ),
                  ' Are your savings invested in the tobacco industry or in entertainment companies that promote tobacco use?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Why tobacco is important.'
                  ),
                  ' Smoking is the leading cause of preventable death in the U.S. and around the world. Most smokers start before they\u2019re 18. ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.cdc, xstrong: true, title: 'CDC: Youth and Tobacco Use' },
                    'Every day, more than 2,000 young Americans become daily smokers.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Many entertainment companies promote smoking.'
                  ),
                  ' Kid-rated movies still depict smoking, even though the U.S. Surgeon General and the scientific community have concluded that smoking scenes in movies cause young people to smoke.'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-vid-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-lede-vid' },
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://vimeo.com/236527794',
                  volume: 0.7 })
              ),
              _react2.default.createElement('div', { styleName: 'x-camera-img' })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-title' },
              'Entertainment companies are recruiting young smokers'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-subtitle' },
              'Making kid-rated movies smokefree would save millions of kids\u2019 lives'
            )
          )
        ),
        _react2.default.createElement(_components.TobaccoSectors, null),
        _react2.default.createElement(
          'div',
          { styleName: 'x-takeaction' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-takeaction-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-takeaction-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-takeaction-photo', title: 'Tell Hollywood to make kid-rated movies smokefree' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-takeaction-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-takeaction-info-title' },
                  'Tell Hollywood to make kid-rated movies smokefree'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-takeaction-info-subtitle' },
                  'America\u2019s best-known entertainment companies have delivered millions of American kids to the tobacco industry'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-takeaction-info-take-action' },
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.speakout, bigbutton: true, title: 'Take action: Tell Hollywood to take smoking out of kid-rated movies!' },
                    'Take action\xA0',
                    _react2.default.createElement('i', { className: 'fa fa-angle-double-right' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.SocialButtons, { message: message, link: link }),
        _react2.default.createElement(
          'div',
          { styleName: 'x-investing' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-investing-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-investing-title' },
              'Is tobacco harmful to your finances?'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-investing-subtitle' },
              'Screen your portfolio for tobacco companies and entertainment companies that promote tobacco'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-investing-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-investing-photo', title: 'Screen your mutual funds for tobacco companies and entertainment companies that promote tobacco' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-investing-info' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'x-investing-top' },
                  'Most retirement savings are in 401k plans offered by our employers. 401k plans mostly offer mutual funds, and it can be hard to find out what companies are inside those funds.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Use Tobacco Free Funds to X-ray your investment funds.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Tobacco Free Funds will tell you if your retirement money is invested in tobacco companies and entertainment companies that promote tobacco. We help you find investment options that support a cleaner and healthier future.'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.about,
                    title: 'About Tobacco Free Funds'
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'link-style' },
                    'Your savings can change the world',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.DonateBanner, null),
        _react2.default.createElement(
          'div',
          { styleName: 'x-testimonials' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-testimonials-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-testimonials-title' },
              'Smoking in movies? See for yourself'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-testimonials-subtitle' },
              'Click a logo below to view the tobacco footprints of America\u2019s best-known entertainment companies'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hover-icon-row' },
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.comcast, title: 'Comcast | UCSF Smoke Free Movies' },
                _react2.default.createElement('img', { styleName: 'hover-icon', src: comcastIcon, alt: 'Comcast | UCSF Smoke Free Movies' })
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.fox, title: 'Fox | UCSF Smoke Free Movies' },
                _react2.default.createElement('img', { styleName: 'hover-icon', src: foxIcon, alt: 'Fox | UCSF Smoke Free Movies' })
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.sony, title: 'Sony | UCSF Smoke Free Movies' },
                _react2.default.createElement('img', { styleName: 'hover-icon', src: sonyIcon, alt: 'Sony | UCSF Smoke Free Movies' })
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.timeWarner, title: 'Warner Brothers - TimeWarner | UCSF Smoke Free Movies' },
                _react2.default.createElement('img', { styleName: 'hover-icon', src: warnerbrothersIcon, alt: 'Warner Brothers - TimeWarner | UCSF Smoke Free Movies' })
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.viacom, title: 'Viacom - Paramount | UCSF Smoke Free Movies' },
                _react2.default.createElement('img', { styleName: 'hover-icon', src: viacomIcon, alt: 'Viacom - Paramount | UCSF Smoke Free Movies' })
              ),
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.independents, title: 'Indies | UCSF Smoke Free Movies' },
                _react2.default.createElement('img', { styleName: 'hover-icon', src: indiesIcon, alt: 'Indies | UCSF Smoke Free Movies' })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-testimonials-info-photo' },
              _react2.default.createElement('div', { styleName: 'x-testimonials-photo', title: 'Percentage of Top-Grossing Youth-Rated Movies with Smoking' }),
              _react2.default.createElement(
                'div',
                { styleName: 'x-testimonials-info' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'x-testimonials-top' },
                  'Breathe California and the University of California, San Francisco, maintain the world\u2019s largest database of on-screen tobacco, covering more than 2,750 U.S. films since 2002. You now have direct online access to the tobacco-promotion track records for every major player in every top-grossing Hollywood film for the last fifteen years and more.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Survey Hollywood\u2019s tobacco trends. Check out tobacco rankings for producers, directors, actors, and other famous names. Compare the tobacco footprints of America\u2019s biggest entertainment companies. Call up individual movie reports. And investigate the Hollywood\u2019s long history of collaborating with tobacco companies to sell smoking to new audiences, traced in once-secret industry documents.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Who\u2019s accountable for putting toxic tobacco imagery in the movies that kids see most? Get the facts.'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.ucsfDatabase,
                    title: 'UCSF Smoke Free Movies Database'
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'link-style' },
                    'UCSF Smoke Free Movies Database',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-testimonials-icons' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-testimonials-icons-info' },
                _react2.default.createElement(
                  'em',
                  null,
                  'Smoke Free Movies Database is a public resource provided by:'
                )
              ),
              _react2.default.createElement('img', {
                styleName: 'x-testimonials-icon',
                src: ucsfTobaccoLogo,
                alt: 'UCSF Center for Tobacco Control Research and Education'
              }),
              _react2.default.createElement('img', {
                styleName: 'x-testimonials-icon',
                src: ucsfSmokeFreeMoviesLogo,
                alt: 'UCSF Smoke Free Movies'
              })
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(_components.TargetDateGrid, null),
        _react2.default.createElement(_components.BenchmarkGrid, null),
        _react2.default.createElement(_components.FamilyGrid, null),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: '_container' },
          _react2.default.createElement(
            'div',
            { styleName: '_container-inner' },
            _react2.default.createElement(_components.PartnerSites, null)
          )
        )
      );
    }
  }]);
  return Home;
}(_react.Component)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1292
// module chunks = 0